export default "<app-list-mapping class=\"flex-column v-100 h-100 flex-grow-1\"></app-list-mapping>\n";